export class IoBlogMockup {
    static blog = {
        'id': '45',
        'name': 'Blog 12 - Radio Show',
        'description': 'Listen to a radio show',
        'content': `
            <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Donec neque dui, accumsan pulvinar lectus sed, faucibus interdum dolor.
            Praesent non nisl ligula. Nullam id dapibus elit. Donec sed congue felis.
            Suspendisse nec nunc sit amet lacus sodales elementum. Pellentesque luctus euismod magna.
            Proin blandit vitae lorem at eleifend. Integer a consectetur quam, in condimentum quam.
            Nulla suscipit mi ut hendrerit eleifend.
            Sed ultricies, mi quis malesuada tincidunt, ipsum felis hendrerit sapien, eget lacinia ligula mauris id sem.
            Aenean dignissim nisi libero, interdum scelerisque tellus fermentum a.
            Donec tincidunt vel libero non scelerisque. Integer sed blandit sapien.
            Pellentesque semper tortor sed leo consectetur cursus. Ut placerat sed urna dictum faucibus.
            Integer quis eros et elit interdum blandit in id massa. Vivamus viverra neque ac tempor venenatis.
            Vestibulum felis dui, tincidunt sit amet tortor id, scelerisque fermentum lectus.
            Morbi dignissim euismod pretium. Donec feugiat et nulla eget volutpat.
            Donec aliquet tristique neque, sit amet bibendum ante suscipit nec. Phasellus sed blandit est.
            Suspendisse vel lectus id tortor varius egestas vel ut metus.
            Praesent fringilla, urna at condimentum mattis, purus augue viverra ligula, in aliquet ipsum sapien id est.
            Ut at nibh ultrices nulla commodo porttitor. Cras elit leo, fringilla non tincidunt eu, scelerisque sed leo.
            Sed ultrices lobortis risus id consectetur.
            Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.
            Sed feugiat mauris sit amet viverra mollis. Suspendisse efficitur sed turpis et pharetra.
            Cras porttitor tortor vel tincidunt interdum.
            Donec sagittis, lectus eleifend ultrices commodo, elit ligula euismod neque, a aliquet nisl metus id erat.
            </p>
        `,
        'publishDate': [
            '2017',
            '10',
            '3'
        ]
    };
}
